import React, { Component } from 'react'
import DatePicker from "react-datepicker"
import RenderInput from './RenderInput'
import { FormGroup } from 'react-bootstrap'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css';

class SingleDatePickerWrapper extends Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.dateFormat = 'DD-MM-YYYY'
  }

  handleChange(date) {
    this.props.input.onChange(moment(date).format(this.dateFormat))
  }

  render () {
    const {
      input, placeholder, label, children,
      meta: {touched, error, active}
    } = this.props

    let klassName = [
          error && touched ? 'error' : '',
          active ? 'active' : ''
        ].join(' ')

    return (
      <FormGroup className={klassName}>
        <DatePicker
          {...this.props}
          className='form-control'
          dateFormat={this.dateFormat}
          selected={input.value ? moment(input.value, this.dateFormat) : null}
          onChange={this.handleChange}
          placeholderText={this.dateFormat}
        />
        {touched && error && <span>{error}</span>}
        {children}
      </FormGroup>
    )
  }
}

export default SingleDatePickerWrapper


// WEBPACK FOOTER //
// ./src/reports/general/javascripts/components/User/FormFields/SingleDatePickerWrapper.jsx